export default {
  DRAG_START: 'dragStart',
  DRAG_STOP: 'dragStop',
  LEFT_EDGE_REACHED: 'leftEdgeReached',
  RIGHT_EDGE_REACHED: 'rightEdgeReached',
  NO_EDGE_REACHED: 'noEdgeReached',
  SYNTHETIC_MOVE: 'syntheticMove',
  MOVE: 'move',
};
